import { render, staticRenderFns } from "./distribution-widget.vue?vue&type=template&id=ba163c32"
import script from "./distribution-widget.vue?vue&type=script&lang=js"
export * from "./distribution-widget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports